var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ValidationEnums } from "@yodlee/common-components/dist/types/enumerations";
import { ValidationUtils } from "@yodlee/common-components/dist/utilities";
import * as LabelConfigs from "./label";
var VALIDATION_CHECK = ValidationEnums.VALIDATION_CHECK;
export var FIRST_NAME = {
    key: 'firstName',
    label: LabelConfigs.NAME,
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.FIRST_NAME, { required: required, min: 3, max: 50, pattern: /^(?!.*[\s])((?=.*[a-zA-Z]){1,})(?=.*)/ }, (_a = {}, _a[VALIDATION_CHECK.REQUIRED] = "Please enter first name", _a[VALIDATION_CHECK.MIN] = "Please enter at least 3 characters", _a)), true);
    },
    placeholder: LabelConfigs.FIRST_NAME.replace(" name", "")
};
export var LAST_NAME = {
    key: 'lastName',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.LAST_NAME, { required: required, min: 1, max: 50, pattern: /^(?!.*[\s])((?=.*[a-zA-Z]){1,})(?=.*)/ }, (_a = {}, _a[VALIDATION_CHECK.REQUIRED] = "Please enter last name", _a[VALIDATION_CHECK.MIN] = "Please enter at least 3 characters", _a)), true);
    },
    label: LabelConfigs.NAME,
    placeholder: LabelConfigs.LAST_NAME.replace(" name", "")
};
export var EMAIL = {
    key: 'email',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.EMAIL, { required: required, max: 254, type: "email" }, (_a = {}, _a[VALIDATION_CHECK.TYPE] = "Please enter a valid email address", _a)), true);
    },
    label: LabelConfigs.EMAIL,
    placeholder: LabelConfigs.EMAIL
};
export var CONFIRM_EMAIL = {
    key: 'confirmEmail',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.CONFIRM_EMAIL, { required: required, max: 254, type: "email" }, (_a = {}, _a[VALIDATION_CHECK.TYPE] = "Please enter a valid email address", _a)), true);
    },
    label: LabelConfigs.CONFIRM_EMAIL,
    placeholder: LabelConfigs.CONFIRM_EMAIL
};
export var USERNAME = {
    key: 'userName',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.USERNAME, { required: required, min: 3, max: 50, pattern: /^(?!.*[\s])((?=.*[a-zA-Z]){1,})(?=.*)/ }, (_a = {}, _a[VALIDATION_CHECK.MIN] = "Please enter at least 3 characters", _a)), true);
    },
    label: LabelConfigs.USERNAME,
    placeholder: LabelConfigs.USERNAME
};
export var USER_TIME_ZONE = {
    key: 'timezone.id',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.USERS_TIME_ZONE, { required: required }), true);
    },
    label: LabelConfigs.USERS_TIME_ZONE,
    placeholder: LabelConfigs.USERS_TIME_ZONE
};
export var COUNTRY_CODE = {
    key: 'phone.code',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.COUNTRY_CODE, { required: required }), true);
    },
    label: LabelConfigs.COUNTRY_CODE,
    placeholder: LabelConfigs.COUNTRY_CODE
};
export var WORK_PHONE = {
    key: 'phone.number',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.MOBILE_PHONE, { required: required, pattern: /^\d{1,12}$/ }, (_a = {}, _a[VALIDATION_CHECK.PATTERN] = "Please enter a valid phone number", _a)), true);
    },
    label: LabelConfigs.WORK_PHONE,
    placeholder: '### - ### - ####'
};
export var EXTENSION = {
    key: 'phone.extension',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.EXTENSION, { required: required, pattern: /^\d{1,6}$/ }), true);
    },
    label: LabelConfigs.EXTENSION,
    placeholder: '######'
};
export var ROLE = {
    key: 'role.id',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.ROLE, { required: required, whitespace: false, max: undefined, min: undefined }), true);
    },
    label: LabelConfigs.ROLE,
    placeholder: 'Select role'
};
export var SUPPORT_PARTNER = {
    key: 'supportPartner.id',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.SUPPORT_PARTNER, { required: required, whitespace: false, max: undefined, min: undefined }), true);
    },
    label: LabelConfigs.SUPPORT_PARTNER,
    placeholder: 'Select support partner'
};
export var STATUS = {
    key: 'status.id',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.STATUS, { required: required, whitespace: false, max: undefined, min: undefined }), true);
    },
    label: LabelConfigs.STATUS,
    placeholder: LabelConfigs.STATUS
};
export var PASSWORD = {
    key: 'password',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.PASSWORD, { required: required, pattern: /^(?!.*[\s])((?=.*[!@#$%^&+=()*]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).{8,256}/ }, (_a = {}, _a[VALIDATION_CHECK.PATTERN] = "Password must meet criteria below", _a)), true);
    },
    label: LabelConfigs.PASSWORD,
    placeholder: LabelConfigs.PASSWORD
};
export var CONFIRM_PASSWORD = {
    key: 'confirmPassword',
    rules: function (required) {
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.CONFIRM_PASSWORD, { required: required }), true);
    },
    label: LabelConfigs.CONFIRM_PASSWORD,
    placeholder: LabelConfigs.CONFIRM_PASSWORD
};
export var USERNAMES = {
    key: 'users',
    rules: function (required) {
        var _a;
        if (required === void 0) { required = true; }
        return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.USERNAMES, { required: required, min: 3, max: 500, pattern: /^(?!.*[\s])((?=.*[a-zA-Z]){1,})(?=.*)/ }, (_a = {}, _a[VALIDATION_CHECK.MIN] = "Please enter at least 3 characters", _a)), true);
    },
    label: LabelConfigs.USERNAMES,
    placeholder: 'Comma seperated User Names'
};
export var VALID_UNTIL = {
    key: "validUntil",
    rules: function (required) { return __spreadArray([], ValidationUtils.getValidationRules(LabelConfigs.VALID_UNTIL, { required: required, max: undefined, whitespace: undefined, min: undefined }), true); },
    label: LabelConfigs.VALID_UNTIL,
    placeholder: 'MM/DD/YYYY 00:00 PM'
};
//# sourceMappingURL=form-field.js.map